import { Outlet, useLocation, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname, location.search]);

  const isHome = location.pathname === '/';

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className={`flex-1 ${isHome ? '' : 'pt-16 md:pt-[72px]'}`}>
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}